/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Bridge: keep the Shopify Subscriptions app block in sync with the theme's variant picker.
//
// The app block renders one <section class="shopify_subscriptions_app_block" data-variant-id="..."> per
// variant and shows one at a time via the .shopify_subscriptions_app_block--hidden class. Its own JS only
// updates that on its INTERNAL radio clicks — it does not listen for the theme's variant change.
//
// The theme fires TWO signals when the variant changes (theme.js _onVariantChanged):
//   1) a "variant:changed" CustomEvent on the product section element (bubbles to document)
//   2) a synthetic native "change" event on the <select name="id"> master selector (also bubbles)
// We listen for BOTH — belt-and-suspenders against any product section that may not bubble
// "variant:changed" cleanly. As a final fallback we also listen for user clicks on the visible
// .product-form__single-selector radios and read the master selector after a microtask, in case
// neither synthetic event reaches us.
function _syncSubscriptionBlocksForVariant(newVariantId) {
  if (!newVariantId) return;
  var blocks = document.querySelectorAll('.shopify_subscriptions_app_block[data-variant-id]');
  if (!blocks.length) return;
  var newId = String(newVariantId);
  blocks.forEach(function (block) {
    block.classList.toggle('shopify_subscriptions_app_block--hidden', String(block.dataset.variantId) !== newId);
  });
}

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail && event.detail.variant;
  if (variant) _syncSubscriptionBlocksForVariant(variant.id);
});

document.addEventListener('change', function (event) {
  var t = event.target;
  if (!t) return;
  if (t.name === 'id' && t.value) {
    _syncSubscriptionBlocksForVariant(t.value);
    return;
  }
  if (t.classList && t.classList.contains('product-form__single-selector')) {
    // Fallback: user changed a variant option directly. After this event the theme will update the
    // master <select name="id">; read it on the next microtask.
    setTimeout(function () {
      var master = document.querySelector('select[name="id"], input[name="id"]');
      if (master && master.value) _syncSubscriptionBlocksForVariant(master.value);
    }, 0);
  }
});


/* ---------------------------------------------------------------------------
   A11y: Flickity marks off-screen slides aria-hidden="true" but leaves them in
   the tab order. When the slide element IS the link (.collection-item), the
   aria-hidden element is itself focusable, which fails axe's aria-hidden-focus
   rule and Lighthouse's agent-accessibility-tree audit.

   Flickity exposes no option for this, so mirror aria-hidden onto tabindex.
   The previous tabindex is stashed so the state is restored when the slide
   scrolls back into view.
--------------------------------------------------------------------------- */
(function () {
  var FOCUSABLE = 'a[href],area[href],button,input,select,textarea,iframe,object,embed,summary,[tabindex]';

  function apply(el, hidden) {
    if (!el.matches || !el.matches(FOCUSABLE)) return;
    if (hidden) {
      if (!el.hasAttribute('data-ch-tabindex')) {
        el.setAttribute('data-ch-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
      }
      el.setAttribute('tabindex', '-1');
    } else if (el.hasAttribute('data-ch-tabindex')) {
      var prev = el.getAttribute('data-ch-tabindex');
      if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
      el.removeAttribute('data-ch-tabindex');
    }
  }

  function syncSlide(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    apply(slide, hidden);
    var kids = slide.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < kids.length; i++) apply(kids[i], hidden);
  }

  function syncAll() {
    var slides = document.querySelectorAll('.flickity-slider > [aria-hidden]');
    for (var i = 0; i < slides.length; i++) syncSlide(slides[i]);
  }

  function start() {
    syncAll();
    new MutationObserver(function (muts) {
      var rescan = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          var p = m.target.parentElement;
          if (p && p.classList.contains('flickity-slider')) syncSlide(m.target);
        } else if (m.addedNodes.length) {
          rescan = true;
        }
      }
      if (rescan) syncAll();
    }).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
